export const dynatraceTags = {
  Dynatrace_event: (data) => {
    return {
      event: 'dynatrace-api-transaction',
      data: {
        actionId: data?.actionId,
        endpoint: data?.endpoint,
        status: data?.status,
        message: data?.message,
        url: data?.url,
        result: data?.result,
        operationName: data?.operationName,
        uuid: data?.uuid,
      },
    };
  },
};
